// extracted by mini-css-extract-plugin
export default {"cls1":"WorkCard-cls1_YRY","cls2":"WorkCard-cls2_eXM WorkCard-cls1_YRY"};